import React from "react";
import { Link } from "react-router-dom";
import CourseCard from "../components/CourseCard";
import "./Home.css";
import Gallery from "../components/Gallery";

const Home = () => {
  const courses = [
    {
      id: 1,
      title: "Care Giver",
      description:
        "Comprehensive training for professional caregiving with both theory and practical components.",
      duration: "1 month theory + 2 months practical",
      discount: "30% OFF",
      color: "turquoise",
    },
    {
      id: 2,
      title: "Child Minder",
      description:
        "Specialized training in child care and development for professional child minders.",
      duration: "1 month theory + 2 months practical",
      discount: "30% OFF",
      color: "pink",
    },
    {
      id: 3,
      title: "Farming",
      description:
        "Modern agricultural techniques and farming practices for sustainable agriculture.",
      duration: "1 month theory + 1 month practical",
      discount: "30% OFF",
      color: "green",
    },
    {
      id: 4,
      title: "Warehouse Packer",
      description:
        "Training in warehouse operations, packing, inventory management and logistics.",
      duration: "1 month theory + 1 month practical",
      discount: "30% OFF",
      color: "blue",
    },
    {
      id: 5,
      title: "Psycho Social Counselling",
      description:
        "Professional training in psychosocial counselling techniques and practices.",
      duration: "Comprehensive online training",
      discount: "30% OFF",
      color: "turquoise",
    },
    {
      id: 6,
      title: "HIV Management",
      description:
        "Specialized training in HIV management, care, and support services.",
      duration: "Comprehensive online training",
      discount: "30% OFF",
      color: "pink",
    },
    {
      id: 7,
      title: "Beauty, Nails & Lashes",
      description:
        "Professional beauty training covering nail technology, eyelash application, and essential beauty treatment.",
      duration: "1 month theory + 2 months practical",
      discount: "30% OFF",
      color: "pink",
    },
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <div className="established-badge">
              <span className="established-badge-icon">&#8226;</span>
              Established in 2020
            </div>
            <h1 className="hero-title">Empowering Through Education & Care</h1>
            <p className="hero-subtitle">
              Passion Care 4 U delivers exceptional, client-centric training in
              specialized short courses at the advanced certificate level.
            </p>
            <div className="hero-buttons">
              <a href="#courses" className="btn btn-primary">
                Explore Courses
              </a>
              <a href="/contact" className="btn btn-secondary">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section section">
        <div className="container">
          <div className="mission-content">
            <h2 className="section-title">Our Mission</h2>
            <p className="mission-text">
              Passion Care 4 U is dedicated to delivering exceptional,
              client-centric training in specialized short courses at the
              advanced certificate level. Our mission is to foster personal
              growth through empathy, respect, and tailored support, guided by a
              unified approach that builds enduring relationships and
              credibility within the industry.
            </p>
          </div>
        </div>
      </section>

      {/* Courses Section */}
      <section id="courses" className="courses-section section">
        <div className="container">
          <h2 className="section-title">Our Training Programs</h2>
          <p className="section-subtitle">
            We offer comprehensive online training programs, complete with
            detailed manual books. We also offer courses through bursaries that
            cover <span className="highlight">50%-100% of tuition</span>.
          </p>

          <p className="section-subtitle">
            We provide assistance with voluntary job placement on
            self-sponsorship based projects.
          </p>

          <div className="courses-grid">
            {courses.map((course) => (
              <CourseCard key={course.id} course={course} />
            ))}
          </div>

          <div className="training-info">
            <h3>Training Structure</h3>
            <div className="training-structure">
              <div className="structure-item">
                <h4>Care Giver / Child Minder</h4>
                <p>
                  2 hours/day, 5 days/week for 1 month (theory), followed by 2
                  months of physical practicals (323 hours).
                </p>
              </div>
              <div className="structure-item">
                <h4>Farming & Warehouse Packer</h4>
                <p>
                  2 hours/day, 3 times/week for 2 weeks (theory), followed by 1
                  month of physical practicals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Locations Section */}
      <section className="locations-section section">
        <div className="container">
          <h2 className="section-title">Online & Physical Training Globally</h2>
          <div className="locations-grid">
            <div className="location-card global">
              <h3>Worldwide</h3>
              <p>
                Global Training: Online/Physical
              </p>
              <p className="location-detail">
                SunShare Tower 1st Floor Katima Mulilo Rd Olympia.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Gallery />

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Your Journey?</h2>
            <p>
              Secure your slot today and get the best on from all our
              comprehensive training programs.
            </p>
            <Link to="/enroll" className="btn btn-primary">
              Enroll Now
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
